var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-footer",
    { attrs: { dark: "", padless: "" } },
    [
      _c(
        "v-card",
        {
          staticClass: "indigo lighten-1 white--text text-center",
          attrs: { width: "100%", flat: "", tile: "" },
        },
        [
          _c(
            "v-card-text",
            _vm._l(_vm.items, function (item, index) {
              return _c(
                "v-btn",
                {
                  key: index,
                  staticClass: "mx-4 white--text",
                  attrs: {
                    href: item.href,
                    title: item.text,
                    target: "_blank",
                    icon: "",
                  },
                },
                [
                  _c("v-icon", { attrs: { size: "24px" } }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(item.icon) +
                        "\n                "
                    ),
                  ]),
                ],
                1
              )
            }),
            1
          ),
          _c("v-card-text", { staticClass: "white--text pt-0" }, [
            _vm._v("\n            Tận tâm trên từng đơn hàng\n        "),
          ]),
          _c("v-divider"),
          _c("v-card-text", { staticClass: "white--text" }, [
            _vm._v("\n            ©2022 — "),
            _c("strong", [_vm._v("All rights reserved by Isaura Bot")]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// src/components/footer/footer.vue